class RuleBuilderError extends Error {}

export default RuleBuilderError;
